import { render, staticRenderFns } from "./NewsAppPushMessages.vue?vue&type=template&id=326dbbdb"
import script from "./NewsAppPushMessages.js?vue&type=script&lang=js&external"
export * from "./NewsAppPushMessages.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports